<template>
  <footer class="bg-white py-20 font-lato pr-[40px] border-t border-gray-100">
			<Container>
				<div class="space-y-3 flex flex-col">
					<div class="flex items-center justify-center gap-x-8">
							<a
                v-if="getBranded && getFooter.companyName"
								class="text-sm text-gray-500 hover:underline font-medium"
								:href="getFooter.companyURL"
								target="_blank"
								rel="noopener noreferrer"
							>
                {{getFooter.companyName}}
							</a>

							<div class="text-sm text-gray-500 font-medium" v-if="getBranded && getFooter.copyrightInfo">
                &copy; {{currentYear}} {{getFooter.copyrightInfo}}
							</div>
					</div>

					<div class="flex justify-center">
						<ul class="flex items-center">
              <li v-for="(item, index) in links" class="flex items-center" :key="item.id">
                <a
                  :href="item.url"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-sm text-gray-500! hover:text-gray-800! font-medium after:content-['|'] after:text-gray-200 after:mx-3"
                  :class="{'after:hidden': index === links.length - 1}"
                  @click="sendEventGA('Footer Link', item.name)"
                >
                  {{ item.name }}
                </a>
              </li>
						</ul>
					</div>
				</div>
        <div class="text-center mt-6" v-if="getFooter.poweredBy">
          <a href="https://homeontour.com" target="_blank" rel="noopener noreferrer" class="text-sm text-gray-500! hover:text-gray-800! font-medium">Powered by HomeOnTour</a>
        </div>
			</Container>
		</footer>
</template>

<script>
  import { mapGetters } from 'vuex';

  import gaMixin from '@/shared/mixins/ga';
  import Container from '../Container';
  export default {
    name: 'Footer',
    mixins: [
      gaMixin
    ],
    components: {
      Container,
    },
    computed: {
      ...mapGetters('tour', ['getBranded', 'getFooter']),
      currentYear () {
        const date = new Date();

        return date.getFullYear();
      },
      links () {
        const privacyPolicy = this.getFooter.privacyPolicy;
        const termsAndConditions = this.getFooter.termsAndConditions;

        return [
          {
            id: 'privacyPolicy',
            name: 'Privacy Policy',
            url: privacyPolicy ? privacyPolicy : 'https://homeontour.com/privacy'
          },
          {
            id: 'termsAndConditions',
            name: 'Terms and Conditions',
            url: termsAndConditions ? termsAndConditions : 'https://homeontour.com/terms'
          }
        ];
      }
    }
  };
</script>
